import axios from 'axios'
import {Notification} from 'element-ui'
import Cookies from 'js-cookie'

import Vue from 'vue'
import App from './App.vue'
// import router from '@/router'


export let isRelogin = { show: false };

//创建axios实例
const service = axios.create({
  // baseURL: "/contingency",//127.0.0.1:16700
  baseURL: "/mgh",//127.0.0.1:16600
  timeout:80000,
  withCredentials:true,
  changeOrigin:true,
})


//request拦截器
service.interceptors.request.use(
  config => {
    // if (Cookies.get("token") != null && Cookies.get("token") != ''&&Cookies.get("token") != undefined){
    //   config.headers['token'] = Cookies.get("token")
    // }
    // else{
    //   let params = {
    //     "password":"adminhk@2024",
    //     "username":"admin"
    //     }
    //   axios.post('http://36.147.33.56:19889/auth/login',params).then(res=>{
    //     Cookies.set("token",res.data.data.token)
    //     config.headers['token'] = Cookies.get("token")
    //   })
    // }
    //   //监控网站token
    //   if (Cookies.get("camareToken") != null && Cookies.get("camareToken") != ''&&Cookies.get("camareToken") != undefined){
    //     config.headers['camareToken'] = Cookies.get("camareToken")
    //   }
      // else{
      //   let params = {
      //     "password":"21232f297a57a5a743894a0e4a801fc3",
      //     "username":"admin"
      //     }
      //   axios.get('http://36.147.33.56:16800/guandao/videoMonitoring/getToken',{params}).then(res=>{
      //     Cookies.set("camareToken",res.data.data)
      //     config.headers['camareToken'] = Cookies.get("camareToken")
      //   })
      // }
      config.headers['Content-Type'] = 'application/json'
      config.headers['Access-Control-Allow-Origin'] = '*'
    // config.data = JSON.stringify(config.data);//数据转化
    // const params = getPreRequest(config);
    // config.headers = { ...params }
    // console.log("config",config)
    return config
  },
  error => {
    Promise.reject(error)
  }
)
// var vm = new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app')


//response拦截器
service.interceptors.response.use(
  response => {
    // console.log("接口请求参数response----",response)
    // if (response.data.code ===403){
    //   let params = {
    //     "password":"adminhk@2024",
    //     "username":"admin"
    //     }
    //   axios.post('http://36.147.33.56:19889/auth/login',params).then(res=>{
    //     Cookies.set("token",res.data.data.token)
    //     location.reload();
    //   })
      // if (!isRelogin.show) {
      //   isRelogin.show = true;
      //   MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
      //       confirmButtonText: '重新登录',
      //       cancelButtonText: '取消',
      //       type: 'warning'
      //     }
      //   ).then(() => {
      //     isRelogin.show = false;
      //     sessionStorage.clear()
      //     router.push('/login')
      //   }).catch(() => {
      //     isRelogin.show = false;
      //   });
      // }
      // return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
      // vm.$router.push('/login')
      // Notification.error({
      //   title: "登录失效！",
      //   duration: 5000
      // })
    // }
    return response.data
  },
  error => {
    // 兼容blob下载出错json提示
    if (error.response.data instanceof Blob && error.response.data.type.toLowerCase().indexOf('json') !== -1) {
      const reader = new FileReader()
      reader.readAsText(error.response.data, 'utf-8')
      reader.onload = function (e) {
        const errorMsg = JSON.parse(reader.result).message
        Notification.error({
          title: errorMsg,
          duration: 5000
        })
      }
    } else {
      let code = 0
      try {
        code = error.response.data.status
      } catch (e) {
        if (error.toString().indexOf('Error: timeout') !== -1) {
          Notification.error({
            title: '网络请求超时',
            duration: 5000
          })
          return Promise.reject(error)
        }
      }

      if (code) {
        if (code === 401) {
          store.dispatch('LogOut').then(() => {
            // 用户登录界面提示
            Cookies.set('point', 401)
            location.reload()
          })
        } else if (code === 403) {
          this.$route.push({ path: '/401' })
        } else {
          const errorMsg = error.response.data.message
          if (errorMsg !== undefined) {
            Notification.error({
              title: errorMsg,
              duration: 0
            })
          }
        }
      } else {
        Notification.error({
          title: '接口请求失败',
          duration: 5000
        })
      }
    }
    return Promise.reject(error)
  }
)


export default service



// WEBPACK FOOTER //
// ./src/request.js